
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_1wepg_1unrh_9",
  "description": "awsui_description_1wepg_1unrh_10",
  "label": "awsui_label_1wepg_1unrh_11",
  "outline": "awsui_outline_1wepg_1unrh_19",
  "show-outline": "awsui_show-outline_1wepg_1unrh_22",
  "native-input": "awsui_native-input_1wepg_1unrh_26",
  "wrapper": "awsui_wrapper_1wepg_1unrh_30",
  "label-wrapper": "awsui_label-wrapper_1wepg_1unrh_36",
  "empty-content": "awsui_empty-content_1wepg_1unrh_47",
  "description-bottom-padding": "awsui_description-bottom-padding_1wepg_1unrh_57",
  "label-disabled": "awsui_label-disabled_1wepg_1unrh_65",
  "description-disabled": "awsui_description-disabled_1wepg_1unrh_66",
  "control": "awsui_control_1wepg_1unrh_70"
};
  